var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _g2, _g3, _g4, _rect, _rect2, _path12, _path13, _path14, _path15, _path16, _circle2, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 742.417,
    height: 712.723,
    viewBox: "0 0 742.417 712.723",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-589 -184)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_274-67",
    "data-name": "Path 274",
    d: "M449.813,328.006s11.621,38.349,8.135,43,37.187-25.566,37.187-25.566-15.107-10.459-9.3-25.566Z",
    transform: "translate(251.695 108.565)",
    fill: "#9f616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_968-68",
    "data-name": "Path 968",
    d: "M853.606,262.605h-3.9V155.628a61.915,61.915,0,0,0-61.915-61.915H561.141a61.915,61.915,0,0,0-61.916,61.915V742.511a61.915,61.915,0,0,0,61.915,61.915H787.788A61.915,61.915,0,0,0,849.7,742.511V338.753h3.9Z",
    transform: "translate(360.209 90.287)",
    fill: "#090814"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_969-69",
    "data-name": "Path 969",
    d: "M837.006,151.481V746.656a46.958,46.958,0,0,1-46.935,46.952H558.764a46.967,46.967,0,0,1-46.973-46.959V151.482a46.965,46.965,0,0,1,46.971-46.951H586.82a22.329,22.329,0,0,0,20.656,30.74H739.344A22.329,22.329,0,0,0,760,104.53h30.055a46.957,46.957,0,0,1,46.951,46.934Z",
    transform: "translate(360.209 90.287)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 96.565,
    cy: 96.565,
    r: 96.565,
    transform: "translate(938 287.564)",
    fill: "#fa0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39-70",
    "data-name": "Path 39",
    d: "M779.672,494.309H574.135a3.81,3.81,0,0,1-3.806-3.806V439.52a3.811,3.811,0,0,1,3.806-3.806H779.672a3.811,3.811,0,0,1,3.806,3.806V490.5a3.811,3.811,0,0,1-3.806,3.806ZM574.135,437.235a2.286,2.286,0,0,0-2.284,2.284V490.5a2.286,2.286,0,0,0,2.284,2.284H779.672a2.286,2.286,0,0,0,2.284-2.284V439.519a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40-71",
    "data-name": "Path 40",
    d: "M637.7,454.074a2.665,2.665,0,0,0,0,5.329H763.3a2.665,2.665,0,0,0,.2-5.326l-.117,0H637.7Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41-72",
    "data-name": "Path 41",
    d: "M637.7,470.058a2.664,2.664,0,1,0,0,5.329H763.3a2.665,2.665,0,0,0,.2-5.326l-.117,0H637.7Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42-73",
    "data-name": "Path 42",
    d: "M779.672,579.289H574.135a3.81,3.81,0,0,1-3.806-3.806V524.5a3.811,3.811,0,0,1,3.806-3.806H779.672a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.8ZM574.135,522.216a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H779.672a2.286,2.286,0,0,0,2.284-2.284V524.5a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43-74",
    "data-name": "Path 43",
    d: "M637.7,539.33a2.664,2.664,0,0,0,0,5.329H763.3a2.665,2.665,0,1,0,.087-5.329H637.7Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44-75",
    "data-name": "Path 44",
    d: "M637.7,555.318a2.664,2.664,0,0,0,0,5.329H763.3a2.665,2.665,0,1,0,.087-5.329H637.7Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2-76",
    "data-name": "Path 39-2",
    d: "M779.672,664.547H574.135a3.81,3.81,0,0,1-3.806-3.806V609.758a3.811,3.811,0,0,1,3.806-3.806H779.672a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806ZM574.135,607.474a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H779.672a2.286,2.286,0,0,0,2.284-2.284V609.758a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2-77",
    "data-name": "Path 40-2",
    d: "M637.7,624.591a2.664,2.664,0,0,0,0,5.329H763.3a2.665,2.665,0,0,0,.2-5.326l-.117,0H637.7Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2-78",
    "data-name": "Path 41-2",
    d: "M637.7,640.578a2.664,2.664,0,0,0,0,5.329H763.3a2.665,2.665,0,0,0,.2-5.326l-.117,0H637.7Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_970-79",
    "data-name": "Path 970",
    d: "M969.27,806.286H230.729c-1.071,0-1.938-.468-1.938-1.045s.868-1.045,1.938-1.045H969.271c1.07,0,1.938.468,1.938,1.045S970.341,806.286,969.27,806.286Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(589 184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438-80",
    "data-name": "Path 438",
    d: "M937.992,765.521a19.474,19.474,0,0,1-18.806-3.313c-6.587-5.528-8.652-14.636-10.332-23.07l-4.97-24.945,10.405,7.165c7.483,5.152,15.134,10.47,20.316,17.933s7.443,17.651,3.28,25.726",
    transform: "translate(-228.791 -93.713)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439-81",
    "data-name": "Path 439",
    d: "M936.385,797.458c1.31-9.542,2.657-19.206,1.738-28.849-.816-8.565-3.429-16.93-8.749-23.789a39.574,39.574,0,0,0-10.153-9.2c-1.015-.641-1.95.968-.939,1.606a37.622,37.622,0,0,1,14.881,17.956c3.24,8.241,3.76,17.224,3.2,25.977-.338,5.294-1.053,10.553-1.774,15.8a.964.964,0,0,0,.65,1.144.936.936,0,0,0,1.144-.65Z",
    transform: "translate(-228.791 -93.713)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442-82",
    "data-name": "Path 442",
    d: "M926.958,782.148a14.336,14.336,0,0,1-12.491,6.447c-6.323-.3-11.595-4.713-16.34-8.9l-14.035-12.4,9.289-.444c6.68-.32,13.533-.618,19.9,1.442s12.231,7.018,13.394,13.6",
    transform: "translate(-228.791 -93.713)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443-83",
    "data-name": "Path 443",
    d: "M940.086,802.943c-6.3-11.156-13.618-23.555-26.685-27.518a29.779,29.779,0,0,0-11.224-1.159c-1.192.1-.894,1.94.3,1.837a27.665,27.665,0,0,1,17.912,4.739c5.051,3.438,8.983,8.217,12.311,13.286,2.039,3.1,3.865,6.341,5.691,9.573C938.971,804.733,940.677,803.988,940.086,802.943Z",
    transform: "translate(-228.791 -93.713)",
    fill: "#f2f2f2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(589 184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 15.986,
    cy: 15.986,
    r: 15.986,
    transform: "translate(355 354.999)",
    fill: "#fa0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-3-84",
    "data-name": "Path 40-3",
    d: "M592.124,461.712c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.944,5.944,0,0,0-.328-2.708h-15.73Z",
    transform: "translate(-228.791 -93.713)",
    fill: "#e6e6e6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(589 184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5-2",
    cx: 15.986,
    cy: 15.986,
    r: 15.986,
    transform: "translate(355 440.292)",
    fill: "#fa0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-4-85",
    "data-name": "Path 40-4",
    d: "M592.124,547.005c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.944,5.944,0,0,0-.328-2.708h-15.73Z",
    transform: "translate(-228.791 -93.713)",
    fill: "#e6e6e6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(589 184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-3",
    "data-name": "Ellipse 5-3",
    cx: 15.986,
    cy: 15.986,
    r: 15.986,
    transform: "translate(355 525.55)",
    fill: "#fa0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-5-86",
    "data-name": "Path 40-5",
    d: "M592.124,632.263c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.941,5.941,0,0,0-.328-2.708h-15.73Z",
    transform: "translate(-228.791 -93.713)",
    fill: "#e6e6e6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 8,
    height: 67,
    transform: "translate(1008.051 363.268) rotate(-45)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 8,
    height: 67,
    transform: "translate(1055.426 357.616) rotate(45)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_254-87",
    "data-name": "Path 254",
    d: "M319.051,549.848a10.056,10.056,0,0,0,5.388-14.447L348,508.537,329.608,506l-19.558,25.9a10.11,10.11,0,0,0,9,17.95Z",
    transform: "translate(360.209 90.287)",
    fill: "#9f616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255-88",
    "data-name": "Path 255",
    d: "M118.679,694.215H102.244L94.425,630.82h24.257Z",
    transform: "translate(589 184)",
    fill: "#9f616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257-89",
    "data-name": "Path 257",
    d: "M204.713,680.461l-15.7,4.873L162.751,627.11l23.166-7.192Z",
    transform: "translate(589 184)",
    fill: "#9f616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_973-90",
    "data-name": "Path 973",
    d: "M334.884,495.656l-24.341,27.877,19.056,1.715Z",
    transform: "translate(360.209 90.287)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975-91",
    "data-name": "Path 975",
    d: "M325.373,531.589s-8.455,4.227-9.512,23.251,3.171,68.7,3.171,68.7-4.227,22.194,0,42.274-4.227,93,1.057,93,32.762,3.171,33.819,0,2.114-50.729,2.114-50.729,8.455-24.308,0-39.1c0,0,29.521,51.548,48.615,90.889,4.179,8.61,35.933-1.057,30.649-10.569s-17.966-52.843-17.966-52.843-9.512-31.706-26.421-45.445l8.455-67.639s17.967-45.445,7.4-51.786S325.373,531.589,325.373,531.589Z",
    transform: "translate(360.209 90.287)",
    fill: "#090814"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 27.478,
    cy: 27.478,
    r: 27.478,
    transform: "translate(689.809 396.765)",
    fill: "#9f616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976-92",
    "data-name": "Path 976",
    d: "M387.727,361.434l-34.16,20.08s-13.08,7.366-17.966,20.08c-5.208,13.55-2.181,32.628,0,36.99,4.227,8.455-1.773,29.592-1.773,29.592l-5.284,48.615s-19.023,17.966-4.227,20.08,41.217-1.057,57.07,0,33.819,3.171,28.535-7.4-11.625-17.967-5.284-39.1c4.962-16.54,4.747-78.383,4.419-104.5A21.025,21.025,0,0,0,398.846,368.1Z",
    transform: "translate(360.209 90.287)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_980-93",
    "data-name": "Path 980",
    d: "M372.407,394.727l3.17,64.468-30.726,62.223-5.211-1.983,31.706-58.127Z",
    transform: "translate(360.209 90.287)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982-94",
    "data-name": "Path 982",
    d: "M407.279,472.932v-7.4L371.35,524.718Z",
    transform: "translate(360.209 90.287)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_983-95",
    "data-name": "Path 983",
    d: "M337.576,306.387l-4.539-1.816s9.5-10.457,22.713-9.548l-3.717-4.092s9.085-3.637,17.345,5.91c4.342,5.019,9.365,10.919,12.5,17.564h4.865l-2.03,4.471,7.106,4.471-7.294-.8a24.74,24.74,0,0,1-.69,11.579l.2,3.534s-8.459-13.089-8.459-14.9V327.3s-4.543-4.092-4.543-6.82l-2.478,3.183-1.239-5-15.28,5,2.476-4.094-9.5,1.364,3.717-5s-10.737,5.91-11.15,10.912-5.781,11.366-5.781,11.366l-2.478-4.547S325.6,313.207,337.576,306.387Z",
    transform: "translate(360.209 92.401)",
    fill: "#090814"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259-96",
    "data-name": "Path 259",
    d: "M355.354,552.839a10.056,10.056,0,0,0,2.738-15.174l18.423-30.62-18.554.768-14.65,28.96a10.11,10.11,0,0,0,12.043,16.067Z",
    transform: "translate(360.209 90.287)",
    fill: "#9f616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_981-97",
    "data-name": "Path 981",
    d: "M397.24,375.175l7.926-1.585s23.779,17.438,16.381,52.314-40.16,87.719-40.16,87.719-7.4,9.512-9.512,11.625-6.341,0-4.227,3.171-3.171,5.284-3.171,5.284-23.251,0-21.137-8.455,38.047-68.7,38.047-68.7L376.1,400.535S371.874,373.061,397.24,375.175Z",
    transform: "translate(360.209 90.287)",
    fill: "#e5e5e5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_277-98",
    "data-name": "Path 277",
    d: "M514.368,783.067s-10.829-7.941-10.829-3.61-12.273,21.658-12.273,21.658-20.214,14.439-3.61,14.439,23.824-2.888,23.824-2.888l17.327-11.551s4.332-5.054,2.888-10.829-6.5-13.717-6.5-13.717S519.422,784.511,514.368,783.067Z",
    transform: "translate(267.08 81.168)",
    fill: "#090814"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_278-99",
    "data-name": "Path 278",
    d: "M409.446,787.859s-1.494-7.471-6.723-3.735S383.3,799.065,383.3,799.065s-26.147,5.976-9.712,13.447,53.787-2.988,53.787-2.988,1.494-23.906,0-23.159S410.193,789.353,409.446,787.859Z",
    transform: "translate(280.5 81.521)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no-access.40c8c897ef19e500aef8089312a77343.svg";
export { ForwardRef as ReactComponent };